import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledRescheduleButton = styled.div`
  position: absolute;
  top: 20px;
  right: 12px;
  display: inline-block;
  cursor: pointer;

  i {
    color: #2b9bff;
    margin-top: 1px;
  }

  &.disabled {
    color: grey !important;
    cursor: not-allowed;
    p {
      color: grey !important;
    }
  }
`;
